import sneakersImg from '../../assets/images/pedometer/permission-sneakers.png';

/**
 * 권한 비동의 재확인 중앙 모달 (Figma 만보기_팝업02)
 */
export default function PedometerPermissionReaskModal({ open, onAllow, onSkip }) {
  if (!open) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[113] flex items-center justify-center bg-black/70 px-5"
      role="dialog"
      aria-modal="true"
      aria-label="만보기 권한 재확인"
    >
      <div className="flex w-full max-w-[320px] flex-col items-center gap-[30px] rounded-2xl bg-white px-5 pb-6 pt-7 shadow-[0px_5px_16px_rgba(0,0,0,0.1)]">
        <div className="flex w-full flex-col items-center gap-5">
          <div className="flex w-full flex-col items-center">
            <div className="mb-0 size-[100px] overflow-hidden rounded-full">
              <img
                src={sneakersImg}
                alt=""
                className="size-full object-cover object-center mix-blend-multiply"
              />
            </div>
            <p className="mt-0 text-center font-['Pretendard'] text-[22px] font-extrabold leading-[1.4] tracking-[0.44px] text-[#333]">
              오늘의 걸음과 보상을
              <br />
              놓치고 계속할까요?
            </p>
          </div>
          <p className="w-full text-center font-['Pretendard'] text-base font-bold leading-[1.4] tracking-[0.32px] text-[#5E5E5E]">
            권한을 허용하지 않으면 걸음 수가 기록되지
            <br />
            않아 오늘의 만보기 보상을 받을 수 없어요.
          </p>
        </div>

        <div className="flex w-full flex-col items-center gap-2.5">
          <button
            type="button"
            className="flex w-full items-center justify-center rounded-lg border-0 bg-gradient-to-b from-[#3B5CD2] to-[#8B68DD] py-4 font-['Pretendard'] text-base font-bold leading-[1.4] text-white outline-none"
            onClick={onAllow}
          >
            권한 허용하기
          </button>
          <button
            type="button"
            className="flex w-full items-center justify-center rounded-lg border-0 bg-[#F4F4F4] py-4 font-['Pretendard'] text-base font-bold leading-[1.4] text-[#919191] outline-none"
            onClick={onSkip}
          >
            이용하지 않기
          </button>
        </div>
      </div>
    </div>
  );
}
